import { getObserver } from '@theme/theme-global';

class ImageWithText extends HTMLDivElement {
  connectedCallback() {
    this.init();
  }

  init() {
    const animation = this.dataset.mediaAnimation || 'once';

    if (animation === 'none') return;
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-animate');
      return;
    }

    this.classList.remove('is-animate');

    const once = animation === 'once';
    const callOnExit = animation === 'every-time-on-scroll';

    this._observer = getObserver({ threshold: 0.1 }, once, callOnExit);
    this._observer.observe(this, (entry) => {
      if (entry.isIntersecting) {
        this.classList.add('is-animate');
      } else if (callOnExit && entry.boundingClientRect.top > 0) {
        this.classList.remove('is-animate');
      }
    });
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.unobserve(this);
      this._observer = null;
    }
  }
}
if (!customElements.get('image-with-text')) {
  customElements.define('image-with-text', ImageWithText, { extends: 'div' });
}
